import { html } from 'htm/preact';
import { useEffect, useState } from 'react';
import { ConcelhoRecord, DistritoRecord } from '@utils/eclipse2026';

/**
 * Dois <select> nativos, o segundo desactivado até o primeiro estar escolhido.
 * Sem typeahead — 308 opções cabem perfeitamente num <select> nativo com type-ahead
 * do próprio SO, e evita embarcar o bundle de typeahead que o ResultadosPresidenciais2026
 * usa só para isto.
 */
export function ConcelhoPicker({ distritos, concelhos, selectedCode, onSelect }: { distritos: DistritoRecord[]; concelhos: Record<string, ConcelhoRecord>; selectedCode: string | null; onSelect: (code: string | null) => void }) {
    const [distritoCode, setDistritoCode] = useState<string>(selectedCode ? (concelhos[selectedCode]?.distrito ?? '') : '');

    // Sincroniza quando a seleção muda de fora (ex.: hash lido no mount, ou clique no mapa).
    useEffect(() => {
        if (selectedCode && concelhos[selectedCode]) {
            setDistritoCode(concelhos[selectedCode].distrito);
        }
    }, [selectedCode]);

    const sortedDistritos = [...distritos].sort((a, b) => a.nome.localeCompare(b.nome, 'pt'));
    const concelhosDoDistrito = distritoCode
        ? (distritos.find(d => d.code === distritoCode)?.concelhoCodes ?? [])
              .map(code => concelhos[code])
              .filter(Boolean)
              .sort((a, b) => a.nome.localeCompare(b.nome, 'pt'))
        : [];

    return html`
        <div class="eclipse-picker">
            <div class="eclipse-picker-field">
                <label for="eclipse-distrito">Distrito</label>
                <select
                    id="eclipse-distrito"
                    onChange=${(e: Event) => {
                        const code = (e.target as HTMLSelectElement).value;
                        setDistritoCode(code);
                        onSelect(null);
                    }}
                >
                    <option value="" selected=${!distritoCode}>Escolha o distrito</option>
                    ${sortedDistritos.map(d => html`<option key=${d.code} value=${d.code} selected=${d.code === distritoCode}>${d.nome}</option>`)}
                </select>
            </div>

            <div class="eclipse-picker-field">
                <label for="eclipse-concelho">Concelho</label>
                <select id="eclipse-concelho" disabled=${!distritoCode} onChange=${(e: Event) => onSelect((e.target as HTMLSelectElement).value || null)}>
                    <option value="" selected=${!selectedCode}>${distritoCode ? 'Escolha o concelho' : 'Escolha primeiro o distrito'}</option>
                    ${concelhosDoDistrito.map(c => html`<option key=${c.dtmnfr} value=${c.dtmnfr} selected=${c.dtmnfr === selectedCode}>${c.nome}</option>`)}
                </select>
            </div>
        </div>
    `;
}
